import { gql } from '@apollo/client';

/**
 * Web product groups this customer may not subscribe to right now, because they
 * hold an active mobile (App Store / Google Play) subscription (PROD-37488).
 *
 * The server evaluates the GrowthBook policy and returns the result, so the
 * frontend holds no policy, no group list and no campaign list — there is
 * nothing here that can drift from the guard in the upgrade mutation.
 */
export const QUERYV2 = gql`
  query GetSubscriptionRestrictionsByToken($token: String!, $campaign: String) {
    getSubscriptionRestrictionsByToken(token: $token, campaign: $campaign) {
      blockedGroups
      reason
    }
  }
`;

export default QUERYV2;
